namespace Areas.Program.Profile {
    "use strict";

 
    export function updateProgram() {
        const form = $("#ProgramProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
     
        const keyId: any = form.option("KeyId");

        if (keyId != null) {
            sendRequest(`/Program/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

 
}